import { IFontSizes } from './typography.types';

const fontSizes: IFontSizes = {
  s: '12px', // 12px
  m: '14px', // 14px
  l: '16px', // 16px
  xl: '20px', // 20px
  xxl: '32px', // 32px
  xxxl: '48px', // 48px
};

export default fontSizes;
